import React from 'react'
import { Button } from '@hub/button'
import { forwardRef } from '@hub/design-system-base'

type ResponsiveButtonProps = React.ComponentProps<typeof Button>

const ResponsiveButton = forwardRef<ResponsiveButtonProps, typeof Button>(
  ({ children, ...props }, ref) => {
    return (
      <>
        <Button
          ref={ref}
          {...props}
          variant="utilityOutline"
          sx={{
            width: '100%',
            display: ['none', null, 'block'],
            borderColor: 'borderSecondary',
          }}
        >
          {children}
        </Button>
        <Button
          {...props}
          variant="utilityOutlineMobile"
          sx={{
            width: '100%',
            display: ['block', null, 'none'],
            borderColor: 'borderSecondary',
          }}
        >
          {children}
        </Button>
      </>
    )
  }
)

export default ResponsiveButton
